import { useNavigate } from 'react-router-dom';
import { Stack, Text, Title } from '@mantine/core';
import { Button } from '@shared/ui';
import '@shared/styles/page.css';
import './NotFoundPage.css';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="page-container not-found-page">
      <div className="not-found-page__card">
        <Stack gap="md" className="not-found-page__content">
          <img
            className="not-found-page__art"
            src={`${import.meta.env.BASE_URL}404-ufo.png`}
            alt=""
            width={174}
            height={174}
          />
          <Title order={1} size="h2">
            Страница не найдена
          </Title>
          <Text c="dimmed" size="sm" maw={360}>
            Такой страницы нет или она была перемещена. Можно вернуться на главную.
          </Text>
          <Button
            variant="primary"
            rightAddon={<span aria-hidden="true">→</span>}
            onClick={() => navigate('/')}
          >
            На главную
          </Button>
        </Stack>
      </div>
    </div>
  );
}
